// extracted by mini-css-extract-plugin
export default {"loginWrapper":"login-layout_loginWrapper__qxCr7","title":"login-layout_title__onK+y","subTitle":"login-layout_subTitle__e4EDL"};